import { APP_NAMESPACE } from 'app/App.constants';
import {
  API_CALL_ERROR,
  DELETING_FILE,
  FETCHING_FILE,
  FILE_DELETED,
  FILE_FETCHED,
  FILE_FORMAT_ERROR,
  FILE_REPLACED,
  FILE_STRUCTURE_ERROR,
  FILE_UPLOADED,
  ModalStatusType,
  NO_FILE,
  REPLACING_FILE,
  SAME_FILE,
  UPLOADING_FILE,
} from 'components/FileUpload/paramsByState';

import { SEARCH_STATUS } from 'utils';

export const BAM_COMMERCIAL_FAMILY_CODES_NAMESPACE = `${APP_NAMESPACE}/BAM_COMMERCIAL_FAMILY_CODES`;

export interface BamCommercialFamilyCodesState {
  fileUploadStatus: BamCommercialFamilyCodesFileUploadStatus;
  bamCommercialFamilyCodes: string[];
  fileInformation: BamCommercialFamilyCodesFileInformation;
  fileInformationForRequest: BamCommercialFamilyCodesFileInformation;
  searchStatus: SEARCH_STATUS;
}

export interface BamCommercialFamilyCodesFileUploadStatus {
  fileStatus: BamCommercialFamilyCodesFileStatus;
  modalStatus: ModalStatusType;
}

export const UPLOAD_FILE = `${BAM_COMMERCIAL_FAMILY_CODES_NAMESPACE}/UPLOAD_FILE`;
export const GET_FILE = `${BAM_COMMERCIAL_FAMILY_CODES_NAMESPACE}/GET_FILE`;
export const DELETE_FILE = `${BAM_COMMERCIAL_FAMILY_CODES_NAMESPACE}/DELETE_FILE`;

export type BamCommercialFamilyCodesFileStatus =
  | typeof FETCHING_FILE
  | typeof REPLACING_FILE
  | typeof NO_FILE
  | typeof UPLOADING_FILE
  | typeof DELETING_FILE
  | typeof FILE_UPLOADED
  | typeof FILE_FORMAT_ERROR
  | typeof FILE_STRUCTURE_ERROR
  | typeof FILE_REPLACED
  | typeof SAME_FILE
  | typeof FILE_FETCHED
  | typeof FILE_DELETED
  | typeof API_CALL_ERROR;

export interface BamCommercialFamilyCodesFileInformation {
  fileName: string;
}
